// extracted by mini-css-extract-plugin
export var base = "_4p-0";
export var updateBanner = "_4p-1";